import {
  DEFAULT_PATTERN_LENGTH,
  DEFAULT_SPEED,
  DEFAULT_TEMPO,
  EMPTY_CELL,
  PROJECT_SCHEMA_VERSION,
  type Cell,
  type Pattern,
  type PatternRow,
  type Project,
} from '@pulsewright/shared';

function emptyRow(): PatternRow {
  // Deep-clone EMPTY_CELL per channel so rows don't share references.
  const cell = (): Cell => ({ ...EMPTY_CELL, effects: [] });
  return {
    pulse1: cell(),
    pulse2: cell(),
    triangle: cell(),
    noise: cell(),
    dpcm: cell(),
  };
}

function emptyPattern(id: number, length = DEFAULT_PATTERN_LENGTH): Pattern {
  return {
    id,
    length,
    rows: Array.from({ length }, emptyRow),
  };
}

/**
 * Create a blank project with 4 empty patterns of 64 rows each.
 * Matches the Phase 1 acceptance criterion in PROJECT_BRIEF.md.
 */
export function createEmptyProject(): Project {
  return {
    version: PROJECT_SCHEMA_VERSION,
    metadata: {
      title: 'Untitled',
      author: '',
      created_at: new Date().toISOString(),
      tempo: DEFAULT_TEMPO,
      speed: DEFAULT_SPEED,
    },
    instruments: [],
    samples: [],
    patterns: [0, 1, 2, 3].map((i) => emptyPattern(i)),
    order: [0, 1, 2, 3],
    loop_point: 0,
    expansion_chips: [],
  };
}
